
import React from 'react';

export const FabricOutOfInventory = ({...props}) => (
  <svg viewBox="0 0 14 12">
    <path fill={props.fill} fillRule="nonzero" d="M5.153.88c0 .648.79 1.178 1.767 1.178.978 0 1.767-.53 1.767-1.178h.978l3.464 3.464c.23.23.23.6 0 .83l-1.667 1.668a.598.598 0 0 1-.83 0l-.767-.59v4.643a.59.59 0 0 1-.589.589H4.564a.59.59 0 0 1-.59-.59v-4.67l-.765.588c-.23.23-.601.23-.83 0L.71 5.174a.587.587 0 0 1 0-.83L4.175.88h.978zM6.92 8.14a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2zm.6-4.2h-1.2v3.6h1.2v-3.6z"/>
  </svg>

);
